export const SelectDT = {
	select: {
		css: ({ dt }) => `
          .p-select-label {
              white-space: unset;
          }
          .p-select-line {
            .p-select-label {
                white-space: nowrap;
            }
          }
        `,
	},
};
